export default {
  name: "collectWriteBillAduitManage",
  created: function () {
    this.init();
  },
  data() {
    return {
      searchForm: {
          billOfLoadingNo: null,
        recCompany: null,
        recAuditState: null,
        sendAuditState: null,
        signAuditState: null,
        applyTime: null,
        sendAuditTime: null,
        recFristAuditTime: null,
        recFinalAuditTime: null,
        signAuditTime: null,
        page: 1,
        pageSize: 50
      },
      tableData: [],
      selected: [],
      total: 0
    }
  },
  methods: {
    init() {
      let conditionParam = this.$routerUtil.getParam();
      if (conditionParam && conditionParam.searchForm) {
        conditionParam = conditionParam.searchForm;
      }
      if (conditionParam) {
        this.$routerUtil.clearParam();
        this.$nextTick(() => {
          this.searchForm = conditionParam;
          this.doSearch();
        });
      }
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.doSearch();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.doSearch();
    },
    rowClick(row) {
      this.$refs.table.toggleRowSelection(row);
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    doReset() {
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields();
      })
    },
    doSearch() {
      var that = this;
      const condition = new Object();
      condition.pageIndex = that.searchForm.page;
      condition.pageSize = that.searchForm.pageSize;
      // condition.receiveCompanyName = that.searchForm.recCompany;
      condition.billOfLoadingNo = that.searchForm.billOfLoadingNo;
      condition.rcAuditStatus = that.searchForm.recAuditState;
      condition.scAuditStatus = that.searchForm.sendAuditState;
      condition.signatureAuditStatus = that.searchForm.signAuditState;
      if (that.searchForm.applyTime) {
        condition.createTimeBeginTime = that.searchForm.applyTime[0];
        condition.createTimeEndTime = that.searchForm.applyTime[1];
      }
      if (that.searchForm.sendAuditTime) {
        condition.scfAuditUserDayBeginTime = that.searchForm.sendAuditTime[0];
        condition.scfAuditUserDayEndTime = that.searchForm.sendAuditTime[1];
      }
      if (that.searchForm.recFristAuditTime) {
        condition.rcfAuditUserDayBeginTime = that.searchForm.recFristAuditTime[0];
        condition.rcfAuditUserDayEndTime = that.searchForm.recFristAuditTime[1];
      }
      if (that.searchForm.recFinalAuditTime) {
        condition.rcsAuditUserDayBeginTime = that.searchForm.recFinalAuditTime[0];
        condition.rcsAuditUserDayEndTime = that.searchForm.recFinalAuditTime[1];
      }

      // 签章方审核时间
      if (that.searchForm.signAuditTime) {
        condition.signAuditUserDayBeginTime = that.searchForm.signAuditTime[0];
        condition.signAuditUserDayEndTime = that.searchForm.signAuditTime[1];
      }
      console.log(condition);
      const param = this.$paramUtil.clearEmpty(condition);
      console.log(param);
      this.$axios({
        method: "get",
        url: "api/receipts/recordManage", // 接口地址
        params: param
      }).then(res => {
        this.tableData = res.data.resultData.rows;
        this.total = res.data.resultData.total;
      }).catch(error => {
        console.log(error);
        this.$message.error('EM-101');
      }); // 失败的返回
    },
    doFristAudit() {
      const row = this.getSelectedRow();
      if (row) {
          if (row.billSignatureFile.length === 0) {
              this.$message({
                  message: this.$t('common.message.needModifyBill'),
                  type: 'warning',
                  center: true
              });
              return;
          }
          if(!row.signatureCompanyId){
              this.$message({
                  message: this.$t('common.message.sendModify'),
                  type: 'warning',
                  center: true
              });
              return;
          }
        const conditionData = new Object();
        conditionData.searchForm = this.searchForm;
        conditionData.row = row;
        this.$router.push('WriteBillFirstAduit');
        this.$routerUtil.setParam(conditionData);
      }
    },
		doCopy() {
			const row = this.getSelectedRow(true);
			if(row){
				const param = {};
				param.shipper = row.shipper;
				param.consignee = row.consignee;
				param.notifyParty = row.notifyParty;
				param.placeOfreceipt = row.placeOfreceipt;
				param.vessel = row.vessel;
				param.portOfLoading = row.portOfLoading;
				param.portOfTransshipment = row.portOfTransshipment;
				param.PortOfDischarge = row.PortOfDischarge;
				param.PlaceOfDelivery = row.PlaceOfDelivery;
				param.freightCharges = row.freightCharges;
				param.NoOfOriginal = row.NoOfOriginal;
				param.declared = row.declared;
				param.voyageNo = row.voyageNo;
				param.preCarriageBy = row.preCarriageBy;
				param.planceAndDate = row.planceAndDate;
				param.forwardingAgent = row.forwardingAgent;
				param.signedBy = row.signedBy;
				param.typeOfMovement = row.typeOfMovement;
				param.finalDestination = row.finalDestination;
				param.totalNumber = row.totalNumber;
				param.goodList = [...row.billGoods];
				param.goodList.forEach(item => {
					delete item.id;
				});
				param.signer = row.signatureCompanyId;
				param.issuingParty_label = row.sendCompanyId;
				param.billingFee = row.sendBillFeeCompanyId;
				param.issuingTime = row.sendBillDate;
				param.portOfDischarge = row.costId;
				param.payment = parseInt(row.payType);

				// 下拉列表选择后获取图片路径
				param.billLogoName = row.billLogoName;
				param.billImageName = row.billImageName;
				const conditionData = {searchForm: {pageIndex: 1, pageSize: 50}, row: param};
				this.$routerUtil.setParam(conditionData);
                // this.$message.success(this.$t('c_writeBillAuditManage.message.copySuccess'));
        this.$message({
          message: this.$t('c_writeBillAuditManage.message.copySuccess'),
          type: 'success',
          center: true
        });
				this.$router.push('/CollectBillManage/AddWriteBill');
				// this.$axios.post('/api/receipts/recordCopy', param).then(response => {
				// 	console.log(response.data.resultData);
				// 	if(response.data.resultData){
				// 		const conditionData = {};
				// 		conditionData.searchForm = {pageIndex: 1, pageSize: 50};
				// 		conditionData.row = response.data.resultData;
				// 		this.$message.success(this.$t('c_writeBillAuditManage.message.copySuccess'));
				// 		this.$routerUtil.setParam(conditionData);
				// 		this.$router.push('/CollectBillManage/UpdateWriteBill');
				// 	}else{
				// 		this.$message.error(this.$t('c_writeBillAuditManage.message.copyError'));
				// 	}
				// }).catch(e => {
				// 	console.log(e);
				// });
			}
		},
    getSelectedRow(doNotCheckAudit) {
      if (this.selected.length > 1) {
        this.$message({
          message: this.$t('common.message.onlyOneRow'),
          type: 'warning',
            center: true
        });
        return null
      }
      if (this.selected.length < 1) {
        this.$message({
          message: this.$t('common.message.atLastOneRow'),
          type: 'warning',
            center: true
        });
        return null
      }
      if (!doNotCheckAudit && (this.selected[0].rcfAuditResult === 1 || this.selected[0].rcfAuditResult === 0)) {
        this.$message({
          message: this.$t('common.message.firstAuditState'),
          type: 'warning',
            center: true
        });
        return null
      }

      return this.selected[0];
    }
  }
}
